export function optimizeBase44Image(url, width = 640, height = 360) {
  if (!url || typeof url !== 'string') return url || '';
  if (!url.includes('media.base44.com/images/public/') || url.includes('/v1/')) return url;
  const clean = url.split('?')[0];
  const filename = clean.split('/').pop() || 'image.png';
  const base = filename.replace(/\.[^.]+$/, '') || 'image';
  const w = Math.max(1, Math.round(Number(width) || 640));
  const h = Math.max(1, Math.round(Number(height) || 360));
  return clean + '/v1/fill/w_' + w + ',h_' + h + ',q_80/' + base + '.webp';
}

export function productCardSrcSet(url) {
  if (!url || !url.includes('media.base44.com/images/public/')) return undefined;
  return optimizeBase44Image(url, 320, 180) + ' 320w, ' +
    optimizeBase44Image(url, 640, 360) + ' 640w, ' +
    optimizeBase44Image(url, 960, 540) + ' 960w';
}

export function squareThumbSrcSet(url) {
  if (!url || !url.includes('media.base44.com/images/public/')) return undefined;
  return optimizeBase44Image(url, 96, 96) + ' 96w, ' +
    optimizeBase44Image(url, 192, 192) + ' 192w';
}
